import { render, staticRenderFns } from "./TicketItem.vue?vue&type=template&id=7e881ba4&scoped=true&"
import script from "./TicketItem.vue?vue&type=script&lang=js&"
export * from "./TicketItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e881ba4",
  null
  
)

export default component.exports